import React from 'react'
import { connect } from 'react-redux'
import { getImage, getImageError } from 'estimate_list/libs/item'
import { setCompareItems, setEstimateItems } from 'estimate_list/libs/action'
import { estimate, scrollTo } from 'estimate_list/libs/util'
import styled from 'styled-components'
import Zzim from "../list/zzim";
// import DefaultLayer from "../layer/defaultLayer";
import { getCookie } from "estimate_list/libs/cookie";
import DefaultOneButtonLayer from "../layer/defaultOneButtonLayer";

class Compare extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            checkedItems: {},
            AllcheckedItems: false,
            compareItems: [],
            onHidden: false,
            onHiddenComparisonLayer: false,
            isLikeHover: false,
            isOpenMoreThan10ItemsModal: false,
            isOpenLessThan2ItemsModal: false,
        }
        this.props.setCompareItems(estimate.listCompareItems())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.compareItems.length === 0) {
            this.setState({ onHidden: true })
        } else if (nextProps.compareItems.length !== this.props.compareItems.length) {
            let checkedItems = {}
            nextProps.compareItems.map((v, _i) => {
                if (this.state.checkedItems[v[0]] === undefined) checkedItems[v[0]] = true
                else {
                    checkedItems[v[0]] = this.state.checkedItems[v[0]]
                }
                return true
            })
            this.setState({ onHidden: false, checkedItems, compareItems: nextProps.compareItems })
        }
    }

    onAllChecked(e) {
        let checkedItems = {}
        this.props.compareItems.map((v, _i) => {
            checkedItems[v[0]] = e.target.checked
            return true
        })
        this.setState({ checkedItems, AllcheckedItems: e.target.checked })
    }

    onChecked(e) {
        let checkedItems = this.state.checkedItems
        checkedItems[e.target.value] = e.target.checked
        this.setState({ checkedItems: checkedItems, AllcheckedItems: false })
    }

    onDeleteItems() {
        let compareItems = []
        let checkedItems = this.state.checkedItems
        this.props.compareItems.map((v, _i) => {
            if (checkedItems[v[0]] === false) {
                compareItems.push(v)
            } else {
                estimate.delCompareItems(v[0])
            }
            return false
        })
        this.props.setCompareItems(compareItems)
    }

    onDeleteOneItem(e, item) {
        e.preventDefault()
        let compareItems = []
        this.props.compareItems.map((v, _i) => {
            if (v[0] === item) {
                estimate.delCompareItems(v[0])

            } else {
                compareItems.push(v)
            }
            return false
        })
        this.props.setCompareItems(compareItems)
    }

    addEstimateItem() {
        let itemIds = []
        let checkedItems = this.state.checkedItems
        Object.keys(checkedItems).map((k) => {
            if (checkedItems[k] === true) {
                itemIds.push(k)
            }
            return true
        })
        let estimateItems = estimate.addEstimateItems(itemIds)
        this.props.setEstimateItems({ estimateItems, type: 'add', itemId: itemIds })
        scrollTo('#estimateList')
        this.onClose()
    }

    addEstimateOneItem(itemId) {
        let estimateItems = estimate.addEstimateItem(itemId)
        this.props.setEstimateItems({ estimateItems, type: 'add', itemId: itemId })
        scrollTo('#estimateList')
    }

    onOpen() {
        this.setState({ onHiddenComparisonLayer: false })
        const element = document.querySelector("#items_compare_body_list")
        const bodyElement = document.querySelector("#items_compare_body")
        const buttonElement = document.querySelector("#btn_item_del")
        element.style.display = 'block'
        bodyElement.style.display = 'block'
        buttonElement.style.display = 'block'
    }

    onClose() {
        this.setState({ onHiddenComparisonLayer: true })
        const listElement = document.querySelector("#items_compare_body_list")
        const bodyElement = document.querySelector("#items_compare_body")
        const buttonElement = document.querySelector("#btn_item_del")
        listElement.style.display = 'none'
        bodyElement.style.display = 'none'
        buttonElement.style.display = 'none'
    }

    /**
     * 쿠키에서 itemId parsing하고 '|'로 연결 후 인코딩
     * ex) 7549747|10321214|32534121 => 7549747%7C10321214%7C32534121
     * @returns {string}
     */
    parsingItemId () {
        const cookieItems = getCookie('item_compare')
        let itemInfoArr = []
        let result = []
        if (cookieItems !== null) {
            const cookieItemsArr = cookieItems.split('||')
            itemInfoArr = cookieItemsArr.map(v => {
                return v.split('^')
            })
            itemInfoArr.map((v,_) => {
                return (
                    result.push(v[0])
                )
            })
        }
        return encodeURIComponent(result.join(','))
    }

    onCompareWindow() {
        const itemLength = this.state.compareItems.length
        if (itemLength > 10) {
            this.setState({isOpenMoreThan10ItemsModal: true})
        } else if (itemLength === 1) {
            this.setState({isOpenLessThan2ItemsModal: true})
        } else {
            const itemIdList = this.parsingItemId()
            window.open(`${process.env.REACT_APP_PC_URL}/compare_spec/${this.props.selectCategory}/${itemIdList}`)
        }
    }


    /** 하트 svg가 fill로 면 색상을 변경할 수 없고
     *  선 부분 색상만 변경되는 형태이기 때문에
     *  css hover 사용하지 않고 classNmae 변경하는 방식으로 구현
     * @param index
     */
    onMouseOverlikeHandler(index) {
        const element = document.getElementById(`like_icon_${index}`)
        if (element) {
            element.className = 'icon-favorite'
        }
    }

    onMouseLeavelikeHandler(index) {
        const element = document.getElementById(`like_icon_${index}`)
        if (element) {
            element.className = 'icon-favorite_border'
        }
    }

    /**
     * 비 로그인 시 찜하기 누른 후 모달창 취소하면 회색 하트 유지되는 문제 해결
     * @param index
     * @param item_zzim_my
     */
    changeLikeDefault(index, item_zzim_my) {
        const element = document.getElementById(`like_icon_${index}`)
        if (element && element.className === 'icon-favorite' && item_zzim_my === '0') {
            element.className = 'icon-favorite_border'
        }
    }

    render() {
        let count = this.state.compareItems.length
        let width = (count + 1) * 120 + 20 + 'px'
        let isPriceComapreItem = false

        if (this.props.domain === 'shopping') {
            isPriceComapreItem = true
        }
        return (
            !this.state.onHidden && (
                <div className="list-body">
                    <div className="list-body_items">
                        <div className="list-body_items_main">
                            <div className="list-body_items_main_box">
                                <ItemsCompare className="items_compare">
                                    <ItemsCompareHead className="items_compare_head">
                                        <TitleH5>
                                            상품비교 {count > 0 ? <CntItems>{count}</CntItems> : ''}
                                        </TitleH5>
                                    </ItemsCompareHead>
                                    <ItemsCompareBody id="items_compare_body">
                                        <form>
                                            <fieldset>
                                                <legend>
                                                    <span>비교</span>
                                                </legend>
                                                <ItemsCompareBodyList id="items_compare_body_list" width={this.props.domain === 'shopping' ? '783' : '723'}>
                                                    {/* <!-- width값 --> */}
                                                    <ScrollItem width={width}>
                                                        {/* <!-- item --> */}
                                                        {this.state.compareItems.map((v, i) => {
                                                            let item_id = v[0]
                                                            let item_name = v[1]
                                                            let item_price = v[2]
                                                            // let cate_name = v[3]
                                                            let cate_id = v[4] || this.props.selectCategory
                                                            let item_zzim_my = v[5]
                                                            let item_cntZzim = v[6]
                                                            // let compareItem = v.split(',')
                                                            let thumbnail = getImage(cate_id, item_id, 300)
                                                            // let checked = this.state.checkedItems[item_id] || true
                                                            return (
                                                                <ItemsCompareBodyListItem key={i} className="items_compare_body_list_item">
                                                                    <a
                                                                        href={`${process.env.REACT_APP_SHOPPING_URL}/${cate_id}/${item_id}/`}
                                                                        rel="noopener noreferrer"
                                                                        target="_blank"
                                                                    >
                                                                        <ThumbnailImg>
                                                                            <ThumnailCheckBox
                                                                                type="checkbox"
                                                                                id={'comId-' + item_id}
                                                                                name="name-trhgg"
                                                                                value={item_id}
                                                                                checked={this.state.checkedItems[item_id]}
                                                                                onChange={(e) => this.onChecked(e)}
                                                                            />
                                                                            <label htmlFor={'comId-' + item_id}>
                                                                                <span className="ir">선택</span>
                                                                            </label>
                                                                            <XCloseIcon className='thumnail_x' type="button"
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: "5px",
                                                                                    left: "92px",
                                                                                    width: "20px",
                                                                                    height: "20px",
                                                                                    backgroundColor: "#DCDCDC"
                                                                                }}
                                                                                onClick={(e) => this.onDeleteOneItem(e,item_id)}>
                                                                                <i className="icon-X_close"/>
                                                                            </XCloseIcon>
                                                                            <ProductImg
                                                                                src={thumbnail.imgUrl}
                                                                                onError={(e) =>
                                                                                    getImageError(e, thumbnail.noImgUrl)
                                                                                }
                                                                                alt="상품이름"
                                                                            />
                                                                        </ThumbnailImg>
                                                                        <ItemName title={`${item_name}`}>{item_name}</ItemName>
                                                                    </a>
                                                                    {item_price === '0' ? (
                                                                        <PriceWrap expected>
                                                                            <span
                                                                                className="zzim_item_compare"
                                                                                onMouseOver={() => this.onMouseOverlikeHandler(i)}
                                                                                onMouseOut={() => this.onMouseLeavelikeHandler(i)}
                                                                                onClick={() => this.changeLikeDefault(i,item_zzim_my)}
                                                                            >
                                                                                <Zzim
                                                                                    f_div={4}
                                                                                    idx={item_id}
                                                                                    selected={item_zzim_my > 0 ? true : false}
                                                                                    count={item_cntZzim}
                                                                                    itemInfo={v}
                                                                                    index={i}
                                                                                >
                                                                                    <input value={i} type="hidden"/>
                                                                                    {item_zzim_my === '1' ?
                                                                                        <i className="icon-favorite" style={{color:'#3281ED'}}></i> :
                                                                                        <i className="icon-favorite_border" id={`like_icon_${i}`}>
                                                                                        </i>
                                                                                    }
                                                                                </Zzim>
                                                                            </span>
                                                                            <span className="price_comparison">
                                                                                {this.props.domain === 'minishop'
                                                                                    ? '일시 품절'
                                                                                    : '가격비교 예정'
                                                                                }
                                                                            </span>
                                                                        </PriceWrap>
                                                                    ) : (
                                                                        <PriceWrap>
                                                                            <span
                                                                                className="zzim_item_compare"
                                                                                onMouseOver={() => this.onMouseOverlikeHandler(i)}
                                                                                onMouseOut={() => this.onMouseLeavelikeHandler(i)}
                                                                                onClick={() => this.changeLikeDefault(i,item_zzim_my)}
                                                                            >
                                                                                <Zzim
                                                                                    f_div={4}
                                                                                    idx={item_id}
                                                                                    selected={item_zzim_my > 0 ? true : false}
                                                                                    count={item_cntZzim}
                                                                                    itemInfo={v}
                                                                                    index={i}
                                                                                >
                                                                                    <input value='zzim' type="hidden"/>
                                                                                    {item_zzim_my === '1' ?
                                                                                        <i className="icon-favorite" style={{color:'#3281ED'}}></i> :
                                                                                        <i className="icon-favorite_border" id={`like_icon_${i}`}>
                                                                                        </i>}
                                                                                </Zzim>
                                                                            </span>
                                                                            <span>
                                                                                <strong>{item_price}</strong>
                                                                                <span className='price_won'>원</span>
                                                                            </span>
                                                                        </PriceWrap>
                                                                    )}
                                                                </ItemsCompareBodyListItem>
                                                            )
                                                        })}
                                                    </ScrollItem>
                                                </ItemsCompareBodyList>

                                                <ItemsCompareBodyAside isPriceComapreItem={isPriceComapreItem}>
                                                    <BodyAsideTopWrapper>
                                                        <SelectAllItemsWrapper>
                                                            <SelectAllItems htmlFor="id-gdfd">
                                                                <input
                                                                    type="checkbox"
                                                                    id="id-gdfd"
                                                                    name="name-gdfd"
                                                                    onChange={(e) => this.onAllChecked(e)}
                                                                    checked={this.state.AllcheckedItems}
                                                                />
                                                                <SelectionBoxText><span>전체</span>선택</SelectionBoxText>
                                                            </SelectAllItems>
                                                        </SelectAllItemsWrapper>
                                                        <ItemDeleteButton
                                                            type="button"
                                                            id="btn_item_del"
                                                            onClick={() => this.onDeleteItems()}
                                                        >
                                                            <i className="icon-trash-o" />
                                                            <span className="choice_del">선택</span><span>삭제</span>
                                                        </ItemDeleteButton>
                                                    </BodyAsideTopWrapper>
                                                    <ItemCompareButton
                                                        type="button"
                                                        onClick={() => this.onCompareWindow()}
                                                    >
                                                        <i className="icon-clipboard" /> 상품사양 비교
                                                    </ItemCompareButton>

                                                    {isPriceComapreItem || (
                                                        <ItemAddButton
                                                            type="button"
                                                            onClick={() => this.addEstimateItem()}
                                                        >
                                                            <i className="icon-in" /> 상품견적 담기
                                                        </ItemAddButton>
                                                    )}
                                                </ItemsCompareBodyAside>
                                            </fieldset>
                                        </form>
                                    </ItemsCompareBody>
                                    {this.state.onHiddenComparisonLayer
                                        ? (
                                            <ItemsCompareCloseButton type="button" onClick={() => this.onOpen()}>
                                                <span>열기</span> <i className="icon-angle-up"/>
                                            </ItemsCompareCloseButton>
                                        ):(
                                            <ItemsCompareCloseButton type="button" onClick={() => this.onClose()}>
                                                <span>닫기</span> <i className="icon-angle-down" />
                                            </ItemsCompareCloseButton>
                                        )
                                    }
                                </ItemsCompare>
                            </div>
                        </div>
                    </div>
                    {this.state.isOpenMoreThan10ItemsModal && (
                        <DefaultOneButtonLayer onClose={() => this.setState({isOpenMoreThan10ItemsModal:false})} text={`<span>한번에 비교 가능한<br/> 상품수는 <b>최대 10개</b> 입니다.</span>`}/>
                        // <DefaultLayer onClose={() => this.setState({isOpenMoreThan10ItemsModal:false})} padding='55px'>
                        //     <p>한번에 비교 가능한</p>
                        //     <p>상품수는 <font className="clrpont1">최대 10개</font> 입니다.</p>
                        // </DefaultLayer>
                    )}
                    {this.state.isOpenLessThan2ItemsModal && (
                        <DefaultOneButtonLayer onClose={() => this.setState({isOpenLessThan2ItemsModal:false})} text={`<span><b>최소 2개이상</b> 상품 선택 시<br/> 비교 가능합니다</span>`}/>

                        // <DefaultLayer onClose={() => this.setState({isOpenLessThan2ItemsModal:false})} padding='55px'>
                        //     <p><font className="clrpont1">최소 2개 이상</font> 상품 선택 시</p>
                        //     <p>비교 가능합니다.</p>
                        // </DefaultLayer>
                    )}
                </div>
            )
        )
    }
}

let mapStateToProps = (state) => {
    return {
        selectCategory: state.initial.selectCategory,
        compareItems: state.estimateAdd.compareItems,
        categoryData: state.estimateAdd.categoryData,
        domain: state.initial.domain,
    }
}

let dispatchData = (dispatch) => {
    return {
        setCompareItems: (compareItems) => dispatch(setCompareItems(compareItems)),
        setEstimateItems: (compareItems) => dispatch(setEstimateItems(compareItems)),
    }
}
export default connect(mapStateToProps, dispatchData)(Compare)

const ItemsCompareHead = styled.div`
  background-color: #333333 !important;
`

const ThumbnailImg = styled.span`
    overflow: hidden;
    display: block;
    border: 1px solid #EFEFEF;
    width: 120px;
    height: 120px;
    position: relative;

    &:hover {
        border: 1px solid #3281ED;
    }

    input[type="checkbox"] {
        appearance: none;
        width: 1.5rem;
        height: 1.5rem;
        border: 1.5px solid #999999;
        background-color: white;
        cursor: pointer;

        &:hover {
            background-color: #418DED;
        }

        &:checked {
            border-color: transparent;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='all_check_box' width='20' height='20' viewBox='0 0 20 20'%3E%3Crect id='사각형_167' data-name='사각형 167' width='20' height='20' fill='%23418ded'/%3E%3Cpath id='패스_50' data-name='패스 50' d='M115.241,144.8l-5.677,5.674-3.076-3.076-1.625,1.625,4.7,4.7,7.3-7.3-1.622-1.625Z' transform='translate(-100.863 -138.799)' fill='%23fff'/%3E%3C/svg%3E");
            background-size: 100% 100%;
            background-position: 50%;
            background-repeat: no-repeat;
            background-color: #418DED;
        }
    }
`

const ProductImg = styled.img`
    width: -webkit-fill-available !important;
`

const XCloseIcon = styled.button`
    z-index: 200;
    position: absolute;
    top: 5px;
    left: 92px;
    border: 1px solid #DCDCDC;
    width: 20px !important;
    height: 20px !important;
    background-color: #DCDCDC;

    .icon-X_close:before {
        content: "\\e98f" !important;
        color: #FFFFFF !important;
        font-size: 13px;
        font-weight: 800;
        display: flex;
        justify-content: center;
        margin: 4px;
        z-index: 200;
    }

    &:hover {
        background-color: #999999 !important;
    }
`

const ThumnailCheckBox = styled.input`
    position: absolute;
    top: 6px;
    left: 7px;
    border: 1px solid #999999;
    width: 20px !important;
    height: 20px !important;
    z-index: 200;

    &:hover {
        color:#418DED;
    }
`

const PriceWrap = styled.span`
    display: flex;
    justify-content: space-between;
    width: 120px;
    height: 25px;
    margin-top: 12px;
    font-size: 12px;
    color: ${props => props.expected ? '#999999' : '#E23714'};
    text-align: right;

    display: -webkit-flexbox;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    text-align: center;

    button {
        height: 20px;
    }

    .zzim_item_compare {
        height: 20px;
    }

    .heart_icon:hover {
        stroke: #C8C8C8 !important;
        path {
            fill: #C8C8C8 !important;
        }
    }

    .icon-favorite {
        color: #C8C8C8;
        font-size: 19px;
    }

    .icon-favorite_border {
        color: #3281ED;
        font-size: 19px;
    }


    strong {
        font-size: 15px;
        font-family: 'Noto Sans KR';
    }
    .price_won {
        color: #999999;
        font-size: 12px;
        font-family: 'Noto Sans KR';
    }

    .price_comparison {
        font-size: 12px;
    }

`

const ScrollItem = styled.div`
    display: flex;
    width: ${props => props.width || '100%'};
    padding: 20px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
`

const ItemName = styled.span`
    font-family: 'Noto Sans KR';
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    width: 120px;
    height: 36px;
    font-size: 13px;
    margin-top: 7px;
    line-height: 19px;

    &:hover {
        text-decoration:underline;
    }
`

const ItemsCompareBodyAside = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    width: 165px;
    height: 100%;
    padding: ${props => props.isPriceComapreItem ? '51px 20px 35px 20px;' : '40px 20px 20px 20px;' }
    border-left: 1px solid #DCDCDC;
    background: #f7f7f7;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 200;
`
const ItemCompareButton = styled.button`
    display: block;
    margin-top: 29px;
    margin-bottom: 10px;
    font-size: 14px;
    width: 100%;
    height: 40px;
    border: 0;
    color: #F7F7F7;
    border-radius: 10px;
    background-color: #333333 !important;
    vertical-align: middle;
    letter-spacing: 0;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    .icon-clipboard:before{
        content: "\\e974";
        font-size: 15px;
    }

    &:hover {
        background-color: #242424 !important;
    }
`

const ItemAddButton = styled.button`
    display: block;
    margin-top: 2px;
    font-size: 14px;
    width: 100%;
    height: 40px;
    color: #F7F7F7;
    border: 0;
    border-radius: 10px;
    background-color: #418DED !important;
    vertical-align: middle;
    letter-spacing: 0;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    &:hover {
        background-color: #3281ED !important;
    }
`

const ItemDeleteButton = styled.button`
    display: block;
    font-family: 'Noto Sans KR';
    margin-top: 2px;
    font-size: 14px;
    width: 100%;
    border: 0;
    color: #666666;
    vertical-align: middle;
    letter-spacing: 0;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    i {
        font-size: 21px;
        vertical-align: inherit;
        margin-right: 5px;
    }
    &:hover {
        .icon-trash-o {
            color: #3281ED;
        }
    }
    .choice_del {
        margin-right: 3px;
    }
    span {
        vertical-align: inherit;
    }
`

const SelectAllItems = styled.label`
    display: flex !important;
    justify-content: center !important;
    font-family: 'Noto Sans KR';
    font-weight: 300;
    margin-top: 2px;
    margin-bottom: 12px;
    font-size: 14px;
    width: 100%;
    height: auto;
    border: 0;
    vertical-align: middle;
    letter-spacing: 0;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    input[type="checkbox"] {
        appearance: none;
        width: 20px;
        height: 20px;
        border: 1.5px solid #999999;
        background-color: white;
        cursor: pointer;
        margin-right: 3px;

        &:hover {
            background-color: #418DED;
        }

        &:checked {
            border-color: transparent;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='all_check_box' width='20' height='20' viewBox='0 0 20 20'%3E%3Crect id='사각형_167' data-name='사각형 167' width='20' height='20' fill='%23418ded'/%3E%3Cpath id='패스_50' data-name='패스 50' d='M115.241,144.8l-5.677,5.674-3.076-3.076-1.625,1.625,4.7,4.7,7.3-7.3-1.622-1.625Z' transform='translate(-100.863 -138.799)' fill='%23fff'/%3E%3C/svg%3E");
            background-size: 100% 100%;
            background-position: 50%;
            background-repeat: no-repeat;
            background-color: #418DED;
        }
    }

    input {
        width: 20px;
        height: 20px;
        margin-right: 5px;
    }
`

const SelectionBoxText = styled.span`
    display: flex !important;
    align-items: center !important;
    font-family: 'Noto Sans KR';
    color: #666666;
    span {
        margin-right: 3px;
    }
`

const SelectAllItemsWrapper = styled.span`
    width: 100%;
`
const BodyAsideTopWrapper = styled.div`
    margin-bottom: 22px;
`

const ItemsCompareBody = styled.div`
    position: relative;
`

const ItemsCompareBodyList = styled.div`
    width: ${props => props.width}px !important;
    overflow-x: auto;
`
const ItemsCompareBodyListItem = styled.div`
    margin-right: 14px;
    font-family: 'Noto Sans KR';
    font-weight: 300;
`

const ItemsCompare = styled.div`
    position: fixed;
    bottom: 0;
    width: 888px;
    border: 1px solid #666666 !important;
    background: #fff;
    z-index: 20;
`

const CntItems = styled.span`
    display: inline-block;
    border-radius: 12px;
    font-size: 14px;
    background: #418ded;
    text-align: center;
    line-height: 24px;
    width: 24px;
    height: 24px;
`

const TitleH5 = styled.h5`
    font-weight: 500;
    height: 50px;
    padding: 0 20px;
    font-size: 16px;
    color: #fff;
    line-height: 50px;
`

const ItemsCompareCloseButton = styled.button`
    font-family: 'Noto Sans KR';
    font-weight: 300;
    position: absolute;
    right: 0;
    top: 10px;
    padding: 0 10px;
    height: 30px;
    border: 0;
    color: #fff;
    background-color: rgba(0,0,0,0);
    vertical-align: middle;
    letter-spacing: 0;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-right: 8px;

    &:hover {
        color:#AAAAAA;
        //text-decoration: underline;
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/compare/index.js